<template>
  <NuxtLoadingIndicator color="var(--primary-2)" />
  <Html :dir="head.htmlAttrs.dir">
    <!-- Leaders Travel (Figma "Top navigation 2.4" over a full-bleed
    transparent hero): reuses the same "supplier-four" nav styling qool
    (and other supplier-four clients) use — transparent over the hero,
    solid on scroll — gated on header.type === "transparent" so the other
    template-two clients (epic, jdtravel, both header.type "normal") keep
    their existing solid nav. -->
    <LayoutTheHeader
      v-if="isTransparentHeader"
      is-supplier-four
      :route-path="routePath"
      @open-login="openLogin"
    />
    <LayoutTheHeader
      v-else
      isTemplate2
      :route-path="routePath"
      @open-login="openLogin"
    />
    <Auth ref="authRef">
      <template #googleSignin>
        <google />
      </template>
    </Auth>
    <main
      :class="
        isTransparentHeader
          ? { 'pt-[3.75rem]': !isHome }
          : isHome
            ? 'pt-[5.5rem]'
            : 'pt-[3.75rem]'
      "
    >
      <slot />
    </main>
    <!-- Leaders Travel (Figma "Footer 2.6", node 5803:971): a dedicated
    footer component for this exact design (logo, help/company/cities
    columns, social squares, payment+copyright bar), opted into via a new
    `footer.variant` flag so the other template-two clients (epic,
    jdtravel) keep their existing TheFooterOneOne footer. -->
    <LayoutTheFooterTwoSix v-if="footerVariant === 'twoSix'" />
    <LayoutTheFooterOneOne v-else />
    <slot name="whats-app">
      <LayoutWhatsappFloatButtonPicker :raised="isProductPage" />
    </slot>
  </Html>
</template>

<script setup lang="ts">
import { provide, ref, watch } from "vue";
const authRef = ref<any>(null);
function openLogin() {
  authRef.value.open();
}
provide("openLogin", openLogin);
const head = useI18nHead();
const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
const footerVariant = config.public.footer?.variant;
const isTransparentHeader = config.public.header?.type === "transparent";

const localePath = useLocalePath();

const route = useRoute();
const routePath = ref(route.path);
const isProductPage = useIsProductPage();

const isHome = ref(true);

watch(
  () => route.path,
  () => {
    routePath.value = route.path;
    isHome.value = route.path == localePath("/");
  },
  { immediate: true }
);
</script>
